<template>
    <label class="bg-white p-2 pl-6 rounded-full flex">
        <input
            type="text"
            class="bg-transparent border-0 p-0 m-0 text-black placeholder-black font-normal focus:ring-0 flex-1 cursor-text"
            :placeholder="placeholder"
            :value="modelValue"
            @change="$emit('update:modelValue', $event.target.value)"
            @keyup.enter="$emit('search')"
            ref="search-input"
        >

        <div class="rounded-full bg-gradient-to-tr from-green-100 to-green-200 w-12 h-12 flex items-center justify-center cursor-pointer"
             @click="$emit('search')">
            <font-awesome-icon class="text-white"
                               size="lg"
                               :icon="['far', 'search']"
            ></font-awesome-icon>
        </div>
    </label>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

export default {
    emits: ["search", "update:modelValue"],
    props: {
        placeholder: String,
        modelValue: String
    },
    components: {
        FontAwesomeIcon
    },
    methods: {
        focus() {
            this.$refs["search-input"].focus();
        }
    }
}
</script>

<style scoped>

</style>
